<template>
	<section class="home-hero" :class="$i18n.locale" ref="hero">
		<TopHero />
		<div class="container">
			<div class="content">
				<div class="left-side" ref="heroText">
					<h1 class="white fadeInUp animated" v-html="$t('Hero.title')"></h1>
					<p class="white fadeInUp animated delay-200">{{ $t('Hero.paragraph_1') }}</p>
				</div>

				<div class="right-side">
					<div ref="whiteBox" class="white-box fadeInUp animated delay-500" :class="$i18n.locale">
						<p>{{ $t('Hero.paragraph_2') }}</p>
						<Button
						:title="$t('Common.button.title')"
						:url="$t('Common.button.url')"
						target="_blank"
						size="small"
						/>
					</div>
				</div>
			</div>
		</div>
	</section>
</template>

<script>
	import Button from '../partials/Button.vue'
	import TopHero from '../partials/TopHero.vue'
	export default {
		name: 'Hero',
		components: { Button, TopHero }
	}
</script>

<style scoped lang="scss">
	section {
		background-image: url($pathToAssets+'/img/hero-image.jpg');
		background-position: center 80px;
		background-repeat: no-repeat;
		background-size: cover;
		height: $heroHeight;
		padding: 0;
	}

	.content {
		@include flex-container;
		margin: 0 auto;
	}

	.left-side,
	.right-side {
		width: 50%;
	}

	.left-side {
		padding-top: 79px;

		p {
			text-align: left;
			margin-top: 18px;
			font-size: 18px;
			margin-left: 0;
			margin-right: 10px;
			margin-left: 0;
		}
	}

	.right-side {
		.white-box {
			position: relative;
			background-color: $white;
			box-shadow: 0 0 40px rgba(0, 0, 0, 0.42);
			width: 267px;
			padding-top: 65px;
			text-align: center;
			padding-bottom: 12px;
			top: 93px;
			right: 0;
			position: absolute;

			p {
				@extend %lato-black;
				color: $blue4Theme;
				font-size: 18px;
				line-height: 25px;
				margin-left: 0;
				margin-top: 7px;
				margin-bottom: 18px;
				padding: 0 10px;
			}

			&::before {
				position: absolute;
				content: '';
				background-image: url($pathToAssets+'img/heart-circled.svg');
				height: 108px;
				width: 108px;
				top: -54px;
				left: 79.5px;
			}
		}
	}

	.fr {
		.left-side {
			padding-top: 40px;
		}

		h1 {
			font-size: 50px;
		}

		.left-side {
			p {
				font-size: 16px;
			}
		}
	}

	@include littleMaxDesktop {
		.fr {
			h1 {
				font-size: 40px;
			}

			.left-side {
				p {
					font-size: 14px;
				}
			}
		}
	}

	@include collapsed {
		.left-side {
			padding-top: 40px;
		}

		h1 {
			font-size: 4vw;
		}
	}

	@include tabletPortrait {
		h1 {
			font-size: 40px;
		}
		.fr {
			h1 {
				font-size: 36px;
			}

			.left-side {
				p {
					font-size: 12px;
				}
			}
		}
	}

	@include mobile {
		section {
			background-image: url($pathToAssets+'/img/hero-image-mobile.jpg');
			height: 790px;
			background-position: center 170px;
		}

		.left-side,
		.right-side {
			width: 100%;
			padding: 30px;

			&.fr {
				padding: 30px 0;
			}
		}

		h1 {
			font-size: 32px;
			line-height: 1.2;
		}

		.left-side {
			p {
				text-align: left;
				margin-top: 10px;
				font-size: 16px;
			}
		}

		.right-side {
			margin-top: -20px;
			z-index: 1;

			.white-box {
				margin: 30px auto -170px;
				position: relative;
				top: 0;
				width: 100%;
				padding: 60px 15px 15px;

				&::before {
					@include X-50;
					left: 50%;
				}

				p {
					margin-bottom: 10px;
				}

				.btn {
					width: 100%;
				}
			}
		}
	}

</style>
